import React, { useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { addIntern } from '../../service/apiService';
import './Interns.css';

function Interns({ user }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    college: '',
    department: '',
    internship_role: '',
    start_date: '',
    end_date: '',
    remarks: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...formData,
      created_by: user?.id,
    };

    const res = await addIntern(payload);
    setLoading(false);

    if (res.status === 'success') {
      alert('Intern added successfully!');
      setFormData({
        name: '',
        phone: '',
        email: '',
        college: '',
        department: '',
        internship_role: '',
        start_date: '',
        end_date: '',
        remarks: '',
      });
    } else {
      alert(`Error: ${res.message || 'Unable to add intern'}`);
    }
  };

  return (
    <div className="interns-page">
      <h3 className="mb-4">Add Intern</h3>

      <Card className="shadow-sm p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Intern Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>College</Form.Label>
                <Form.Control
                  type="text"
                  name="college"
                  value={formData.college}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Department</Form.Label>
                <Form.Control
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Internship Role</Form.Label>
                <Form.Control
                  type="text"
                  name="internship_role"
                  value={formData.internship_role}
                  onChange={handleChange}
                  placeholder="e.g. React Developer Intern"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Any notes about this intern"
            />
          </Form.Group>

          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Intern'}
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default Interns;
